const Reminder2Notification = `Olá _*{{CONTACT.NAME}}*_, tudo bem? 🤭

Ajuda a gente vai, precisamos muito de você de novo! 🙏

Conta pra gente como está indo sua recuperação pós-parto?

Para isso, uma passadinha aqui: {{LINK.FORMS}}

Sua opinião é super importante para o nosso projeto! Compartilhe sua experiência conosco até _{{CALENDAR.END_AT}}_. 🙏

Até mais,

_*{{USER.NAME}}*_ e _*Equipe Projeto PEARLS Brazil*_ _UNIFESP_`;

export { Reminder2Notification };
